// extracted by mini-css-extract-plugin
export default {"centered":"JoraEmployerFooter__centered","copyright":"JoraEmployerFooter__copyright","wrapper":"JoraEmployerFooter__wrapper","footer":"JoraEmployerFooter__footer"};